export const SET_STARASSIGNMENT_LIST = "SET_STARASSIGNMENT_LIST"
export const SET_STARTYPES_LIST= "SET_STARTYPES_LIST"
export const SET_STARASSIGNMENT_TYPE_CATEGORY = "SET_STARASSIGNMENT_TYPE_CATEGORY";
export const SET_STARASSIGNMENT_SEARCHAFFILIATES = "SET_STARASSIGNMENT_SEARCHAFFILIATES";
export const SET_CARDSLIST = "SET_CARDSLIST";
export const SET_LIST_HISTORICAL_TEMPLATE = "SET_LIST_HISTORICAL_TEMPLATE";
export const SET_DOWNLOAD_TEMPLATE = "SET_DOWNLOAD_TEMPLATE";
export const SET_POST_TEMPLATE = "SET_POST_TEMPLATE";
export const SET_LIST_TYPE_STAR_LIST = "SET_LIST_TYPE_STAR_LIST";
export const SET_ZEN_STAR_REQUESTS = "SET_ZEN_STAR_REQUESTS";
export const SET_STAR_ZEN_STATUS = "SET_STAR_ZEN_STATUS";
export const SET_JOB_STATUS = "SET_JOB_STATUS";
